import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChangePassword from "./Pages/ChangePassword";
import EmailVerification from "./Pages/EmailVerification";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import ResetPassword from "./Pages/ResetPassword";
import ResetPasswordConfirm from "./Pages/ResetPasswordConfirm";
import Signup from "./Pages/Signup";
import Layout from "./High Order Function/Layout";
import Template from "./Pages/Template";
import Dashboard from "./Pages/Dashboard";
import ResumeContext from './Context/ResumeContext';
import Profile from "./Pages/Profile";
import Pricing from "./Pages/Pricing";
import TermsAndConditions from "./Pages/TermsAndConditions";
import AboutUs from "./Pages/AboutUs";
import Contactus from "./Pages/Contactus";
import "./css/main.css";
import { Provider } from "react-redux";
import Store from "./Store";
import CreateResume from "./Pages/CreateResume";
import Privacypage from "./Pages/Privacypage";
import Checkout from "./Pages/Checkout";
import Payments from "./Pages/Payments";
import {ToastContainer} from 'react-toastify';

const App = () => {
  const resumeContextValue = {
    currentTheme: 'Theme1',
    showComponent: false,
    themeData: {},
    componentRef: null
  };

  return (
    <ResumeContext.Provider value={resumeContextValue}>
      <Provider store={Store}>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              {/* <Route path="change/password" element={<ChangePassword />} /> */}
              <Route path="profile" element={<Profile />} />
              <Route path="reset/password" element={<ResetPassword />} />
              <Route path="dj-rest-auth/registration/account-confirm-email/:key" element={<EmailVerification />} />
              <Route path="reset/password/confirm/:uid/:token" element={<ResetPasswordConfirm />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pricing" element={<Pricing />}/>
              <Route path="termsAndConditions" element={<TermsAndConditions />}/>
              <Route path="about-us" element={<AboutUs />}/>
              <Route path="contact-us" element={<Contactus/>} />
              <Route path="privacy-page" element={<Privacypage/>}/>
              <Route path="create-resume" element={<CreateResume />} />
              <Route path="template" element={<Template />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="payments" element={<Payments />} />
            </Routes>
          </Layout>
          <ToastContainer />
        </Router>
      </Provider>
    </ResumeContext.Provider>
  );
}

export default App;
